import React, { useMemo } from 'react';
import Paypal from 'theme/icons/payments/paypal';
import Ababank from 'theme/icons/payments/ababank';
import Bank from 'theme/icons/payments/bank';
import Sepa from 'theme/icons/payments/sepa';
import Sureremit from 'theme/icons/payments/sureremit';
import Stripe from 'theme/icons/payments/stripe';
import Shopify from 'theme/icons/payments/shopify';

function PaymentIcon({ paymentMethodCode }) {
  const paymentIcon = useMemo(() => {
    switch (paymentMethodCode) {
      case 'PAYPAL':
        return <Paypal width="80" />;
      case 'ABA':
        return <Ababank width="80" />;
      case 'BANK':
        return <Bank width="80" />;
      case 'PAYONEER':
        return <img src="/images/logo_payoneer.png" width="80" alt="logo" />;
      case 'SEPA':
        return <Sepa width="80" />;
      case 'SURE_REMIT':
        return <Sureremit width="80" />;
      case 'SHOPIFY_PAYPAL':
        return <Paypal width="80" />;
      case 'BRAINTREE':
        return <Paypal width="80" />;
      case 'STRIPE':
        return <Stripe width="80" />;
      case 'SHOPIFY':
        return <Shopify width="80" />;
      case 'SHOPIFY_BANK_30':
        return <Shopify width="80" />;
      case 'SHOPIFY_BANK_60':
        return <Shopify width="80" />;
      case 'SHOPIFY_CC':
        return <Shopify width="80" />;
      default:
        return <div />;
    }
  }, [paymentMethodCode]);

  return paymentIcon;
}

export default PaymentIcon;
